import {AccountSignInRequestPayload, IdpMetadataRequestPayload} from './SsoConfig.types'
import {ActionType, dispatcherActionType} from '../../../core/utils/interfaces'
import {actionErrorNotifier} from '../../../core/utils/helpers'
import {actionCoreApi} from '../../../core/utils/api'
import ActionsList from '../../../core/actions/Actions.list'
import HTTPUrlHelper from '../../helpers/HTTPUrlHelper'

export const createAccountSignIn = (payload: AccountSignInRequestPayload): dispatcherActionType =>
  actionCoreApi(
    ActionsList.CreateAccountSignIn,
    HTTPUrlHelper.createAccountSignInAPI(),
    'POST',
    payload)

export const getAccountSignIn = (id: string): dispatcherActionType =>
  actionCoreApi(
    ActionsList.CreateAccountSignIn,
    HTTPUrlHelper.getAccountSignInAPI(id),
    'GET')

export const createIdpMetadata = (payload: IdpMetadataRequestPayload, federationProviderId: string, message?: any): ActionType => {
  return actionErrorNotifier(
    actionCoreApi(
      ActionsList.CreateIdpMetadata,
      HTTPUrlHelper.createIdpMetadataAPI(federationProviderId),
      'PUT',
      payload )
    , true,
    {
      title: '',
      message: message ? message : 'notifications.authConfig.createAuthConfigSuccess',
      translateMessage : message === 'notifications.authConfig.createAuthConfigSucces'
    }
  )
}